<template>
    <div class="animated fadeIn">
        <div class="card admin">
            <div class="card-header">
                Список виртуальных номеров
                <div class="pull-right" style="margin-top: 7px">
                    <button class="btn btn-secondary" :class="{ active: showFilter }" data-toggle="dropdown" href="#" @click.prevent="showFilter = !showFilter">
                        <i class="fa fa-filter"></i> Фильтр
                    </button>
                    <button class="btn btn-primary" @click.prevent="showModal">
                        <i class="fa fa-plus"></i> Добавить виртуальный номер
                    </button>
                </div>

                <div v-if="showFilter" class="mt-1">
                    <div class="row col-12">
                        <form @submit.prevent="search" сlass="form-horizontal">
                            <div class="form-group row">
                                <label class="col-md-3 form-control-label">Номер телефона</label>
                                <div class="col-md-5">
                                    <input type="text" class="form-control" v-model="params.query">
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 form-control-label">Город</label>
                                <div class="col-md-5">
                                    <multiselect
                                            :options="cities"
                                            :searchable="true"
                                            :close-on-select="true"
                                            :show-labels="false"
                                            placeholder="Город не выбран"
                                            track-by="id" label="name"
                                            @input="changeCity"
                                    >

                                    </multiselect>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="col-6"></div>
                </div>
            </div>
            <div class="card-block admin__list">
                <div class="row mb-1 text-muted small">
                    <div class="col-1 d-none d-lg-block">Id</div>
                    <div class="col-6 col-md-3 col-lg-2">Номер</div>
                    <div class="col-6 col-md-2">Название</div>
                    <div class="col-6 col-md-1">Город</div>
                    <div class="col-6 col-md-2">Страна</div>
                    <div class="col-6 col-md-2">Сайт</div>
                    <div class="col-6 col-md-2">Действие</div>
                </div>
                <loading v-if="loading" message="Загружаем номера..."></loading>
                <div v-else class="row mb-1 admin__list__item admin__list__item_hover-bg-gray" v-for="item in items">
                    <div class="col-1 d-none d-lg-block">{{item.id}}</div>
                    <div class="col-6 col-md-3 col-lg-2">{{item.number}}</div>
                    <div class="col-6 col-md-2">{{item.name}}</div>
                    <div class="col-6 col-md-1"><span v-if="item.city">{{item.city.name}}</span></div>
                    <div class="col-6 col-md-2">{{item.country}}</div>
                    <div class="col-6 col-md-2">{{item.site}}</div>
                    <div class="col-6 col-md-2">
                        <loading v-if="blockLoading === item.id" :size="2" :message="false"></loading>
                        <template v-else>
                            <button class="btn btn-primary btn-sm" @click.prevent="editItem(item)">
                                <i class="fa fa-edit"></i> Изменить
                            </button>
                        </template>
                    </div>
                </div>
            </div>
            <div class="card-header">
                <b-pagination class="mb-0" size="md" :total-rows="itemsPage.paginator.total_count" v-model="params.page" :per-page="itemsPage.paginator.limit">
                </b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
  import Multiselect from 'vue-multiselect'
  import getVirtualNumbersQuery from './../../../gql/queries/PBX/getVirtualNumbers.graphql'
  import { mapActions, mapState } from 'vuex'
  import { ADD_TOAST_MESSAGE } from 'vuex-toast'
  export default {
    computed: {
      items () {
        return this.itemsPage.virtualNumbers
      },
      ...mapState({
        cities: state => state.globalStore.cities
      })
    },
    data () {
      return {
        params: {
          page: 1,
          query: '',
          cityId: null
        },
        itemsPage: {
          virtualNumbers: null,
          paginator: {
            total_count: 10
          }
        },
        companies: [],
        blockLoading: false,
        showFilter: false,
        loading: false
      }
    },
    name: 'virtualNumbers',
    components: {
      Multiselect
    },
    methods: {
      showModal () {
        this.$store.dispatch('setAdminModal', 'addEditVirtualNumber')
      },
      editItem (item) {
        this.$store.commit('SET_ADMIN_EDIT_VIRTUAL_NUMBER', item)
        this.showModal()
      },
      ...mapActions({
        addToast: ADD_TOAST_MESSAGE
      }),
      changeCity (city) {
        this.params.companyId = null
        if (city) {
          this.params.cityId = city.id
        } else {
          this.params.cityId = null
        }
      }
    },
    apollo: {
      itemsPage: {
        query: getVirtualNumbersQuery,
        variables () {
          return {
            page: this.params.page,
            query: this.params.query,
            cityId: this.params.cityId
          }
        },
        fetchPolicy: 'network-only',
        watchLoading (isLoading, countModifier) {
          this.loading = isLoading
        },
        update: (data) => {
          return data
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// VirtualNumbers.vue?df0be592